import { IndicationYesNoOptions, OptionalIndicationYesNoOptions } from "../helpers/index";

import { BasicMetadata, EditMetadata } from "./MetaData";
import { MonitoringTube } from "./MonitoringTube";
import { Task } from "./Task";
export const deliveryContextGMWOptions = [
  {
    value: "GBM",
  },
  {
    value: "KRW",
  },
  {
    value: "monitoringBijDrinkwaterwinning",
    label: "Monitoring bij drinkwaterwinning",
  },
  {
    value: "NBW",
  },
  {
    value: "NR",
  },
  {
    value: "OGW",
  },
  {
    value: "OW",
  },
  {
    value: "publiekeTaak",
    label: "Publieke taak",
  },
  {
    value: "WW",
  },
  {
    value: "archiefoverdracht",
    label: "Archiefoverdracht",
    onlyImbroA: true,
  },
] as const;
export type DeliveryContextGMWOptions = (typeof deliveryContextGMWOptions)[number]["value"];
export const constructionStandardOptions = [
  {
    value: "BWsb",
  },
  {
    value: "geen",
    label: "Geen",
  },
  {
    value: "IBR",
  },
  {
    value: "NEN5104",
    label: "NEN 5104",
  },
  {
    value: "NEN5744",
    label: "NEN 5744",
  },
  {
    value: "NEN5766",
    label: "NEN 5766",
  },
  {
    value: "RWSgwmon",
    label: "RWS gwmon",
  },
  {
    value: "SIKB2001v6",
    label: "SIKB 2001 v6",
  },
  {
    value: "STOWAgwst",
    label: "STOWA gwst",
  },
  {
    value: "VKB2001",
    label: "VKB 2001",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const constructionStandardValues = constructionStandardOptions.map(({ value }) => value);
export type ConstructionStandardOptions = (typeof constructionStandardOptions)[number]["value"];

export const initialFunctionOptions = [
  {
    value: "brandput",
    label: "Brandput",
  },
  {
    value: "kwaliteit",
    label: "Kwaliteit",
  },
  {
    value: "kwaliteitStand",
    label: "Kwaliteit stand",
  },
  {
    value: "onttrekking",
    label: "Onttrekking",
  },
  {
    value: "stand",
    label: "Stand",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const initialFunctionStandardValues = initialFunctionOptions.map(({ value }) => value);
export type InitialFunctionOptions = (typeof initialFunctionOptions)[number]["value"];

export const wellHeadProtectorOptions = [
  {
    value: "geen",
    label: "Geen",
  },
  // In new version available
  // {
  //   label: "Koker deels metaal",
  //   value: "kokerDeelsMetaal",
  // },
  {
    label: "Koker metaal",
    value: "kokerMetaal",
  },
  {
    label: "Koker niet metaal",
    value: "kokerNietMetaal",
  },
  {
    label: "Pot niet waterdicht",
    value: "potNietWaterdicht",
  },
  {
    label: "Pot waterdicht",
    value: "potWaterdicht",
  },
  {
    value: "koker",
    label: "Koker",
    onlyImbroA: true,
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
  {
    value: "pot",
    label: "Pot",
    onlyImbroA: true,
  },
] as const;

export const wellHeadProtectorStandardValues = wellHeadProtectorOptions.map(({ value }) => value);
export type WellHeadProtectorOptions = (typeof wellHeadProtectorOptions)[number]["value"];

export const positioningMethodOptions = [
  {
    value: "DGPS50tot200cm",
    label: "D GPS 50 tot 200cm",
  },
  {
    value: "GPS200tot1000cm",
    label: "GPS 200 tot 1000cm",
  },
  {
    value: "RTKGPS0tot2cm",
    label: "RTK GPS 0 tot 2cm",
  },
  {
    value: "RTKGPS2tot5cm",
    label: "RTK GPS 2 tot 5cm",
  },
  {
    value: "RTKGPS5tot10cm",
    label: "RTK GPS 5 tot 10cm",
  },
  {
    value: "RTKGPS10tot50cm",
    label: "RTK GPS 10 tot 50cm",
  },
  {
    value: "tachymetrie0tot10cm",
    label: "Tachymetrie 0 tot 10cm",
  },
  {
    value: "tachymetrie10tot50cm",
    label: "Tachymetrie 10 tot 50cm",
  },
  {
    value: "GBKNOnbekend",
    label: "GBKN Onbekend",
    onlyImbroA: true,
  },
  {
    value: "GPSOnbekend",
    label: "GPS Onbekend",
    onlyImbroA: true,
  },
  {
    value: "kaartOnbekend",
    label: "Kaart onbekend",
    onlyImbroA: true,
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const positioningMethodStandardValues = positioningMethodOptions.map(({ value }) => value);
export type PositioningMethodOptions = (typeof positioningMethodOptions)[number]["value"];

export const verticalDatumOptions = [
  {
    value: "NAP",
  },
] as const;
export const verticalDatumStandardValues = verticalDatumOptions.map(({ value }) => value);
export type VerticalDatumOptions = (typeof verticalDatumOptions)[number]["value"];

export const groundLevelPositioningMethodOptions = [
  {
    value: "AHN2",
  },
  {
    value: "AHN3",
  },
  {
    value: "AHN4",
  },
  {
    value: "RTKGPS0tot4cm",
    label: "RTK GPS 0 tot 4cm",
  },
  {
    value: "RTKGPS4tot10cm",
    label: "RTK GPS 4 tot 10cm",
  },
  {
    value: "RTKGPS10tot20cm",
    label: "RTK GPS 10 tot 20cm",
  },
  {
    value: "RTKGPS20tot100cm",
    label: "RTK GPS 20 tot 100cm",
  },
  {
    value: "tachymetrie0tot10cm",
    label: "Tachymetrie 0 tot 10cm",
  },
  {
    value: "tachymetrie10tot50cm",
    label: "Tachymetrie 10 tot 50cm",
  },
  {
    value: "waterpassing0tot2cm",
    label: "Waterpassing 0 tot 2cm",
  },
  {
    value: "waterpassing2tot4cm",
    label: "Waterpassing 2 tot 4cm",
  },
  {
    value: "waterpassing4tot10cm",
    label: "Waterpassing 4 tot 10cm",
  },
  {
    value: "afgeleidBovenkantBuis",
    label: "Afgeleid bovenkant buis",
  },
  {
    value: "AHN1",
    onlyImbroA: true,
  },
  {
    value: "geen",
    label: "Geen",
    onlyImbroA: true,
  },
  {
    value: "GPSOnbekend",
    label: "GPS onbekend",
    onlyImbroA: true,
  },
  {
    value: "kaartOnbekend",
    label: "Kaart onbekend",
    onlyImbroA: true,
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const groundLevelPositioningMethodStandardValues = groundLevelPositioningMethodOptions.map(
  ({ value }) => value
);
export type GroundLevelPositioningMethodOptions =
  (typeof groundLevelPositioningMethodOptions)[number]["value"];

export const wellStabilityOptions = [
  {
    value: "instabiel",
    label: "Instabiel",
  },
  {
    value: "stabielNAP",
    label: "Stabiel NAP",
  },
  {
    value: "",
    label: "Niet van toepassing",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const wellStabilityStandardValues = wellStabilityOptions.map(({ value }) => value);
export type WellStabilityOptions = (typeof wellStabilityOptions)[number]["value"];

export type GMWStartRegistrationData = {
  objectIdAccountableParty: string;
  nitgCode: string;
  deliveryContext: string;
  constructionStandard: ConstructionStandardOptions;
  initialFunction: InitialFunctionOptions;
  numberOfMonitoringTubes: number; // Between 0 and 50
  groundLevelStable: IndicationYesNoOptions;
  owner: string;
  maintenanceResponsibleParty: string;
  wellHeadProtector: WellHeadProtectorOptions;
  wellConstructionDate: string;
  deliveredLocation: string;
  horizontalPositioningMethod: PositioningMethodOptions;
  localVerticalReferencePoint: string;
  offset: string;
  verticalDatum: VerticalDatumOptions;
  groundLevelPosition: string;
  groundLevelPositioningMethod: GroundLevelPositioningMethodOptions;
  wellStability: WellStabilityOptions;
  isAbroad: OptionalIndicationYesNoOptions;
  geometricDataPubliclyAvailable: OptionalIndicationYesNoOptions;
  relatedSurveys: string[];
  monitoringTubes: MonitoringTube[];
};

export type CreateGMWTask = Task<GMWStartRegistrationData, BasicMetadata>;
export type EditGMWTask = Task<GMWStartRegistrationData, EditMetadata>;
